import React, { useState, useEffect } from "react";
import '../../../CSS/Materiales.css'
import { URIMG, getPermission } from "../../../Conexiones/Conexion";
import { BsPlus } from "react-icons/bs";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Button, CloseButton, Modal } from 'react-bootstrap';
import { FaArrowLeftLong } from "react-icons/fa6";
import { deleteApi, getApi, postApiImg, putApi, putApiImg } from "../../../Conexiones/Models";
import { errorMessage, errorToast, successToast, warningModal, warningToast } from "../../../Utils/AlertMessage";
import Loading from "../../../Utils/Loading";

function Categorias() {
    const [categorias, setCategoria] = useState([]);
    const navigate = useNavigate();
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const uri = 'catmat/';
    const [isLoading,setIsLoading]=useState(false);

    //AGREGAR
    const [imagenCategoria, setImagenCategoria] = useState(null);
    const [show, setShow] = useState(false);
    const handleClose = () => {setShow(false); setImagenCategoria(null);}
    const handleShow = () => setShow(true);
    const [nombreCategoria, setNombreCategoria] = useState();
    const [imgCat, setImgCat] = useState('');
    const [isSaving, setSaving] = useState(false);
    //EDITAR
    const [editimagenCategoria, setEditImagenCategoria] = useState(null);
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => {setShowEdit(false);setEditImagenCategoria(null);setImgCat('')}
    const [editnombreCategoria, setEditNombreCategoria] = useState();
    const [idMaterial,setidMaterial] = useState ()
    const handleShowEdit = (id,nombre,img) =>{
        setShowEdit(true);
        setEditNombreCategoria(nombre);
        setidMaterial(id);
        setImgCat(img);
    }
   
    const getCategorias = async () => {
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setCategoria(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    };

    useEffect(() => {
        const getCategorias = async () => {
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,14);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setCategoria(res.data);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        };
        getCategorias();
    },[idUsuario,navigate]);

    const regresar = () => {
        navigate('/inicio/Catalogos')
    }
    const select = (id) => {
        sessionStorage.setItem("categoria", id);
        navigate("Tabla-Materiales");
    };

    //ELIMINAR
    const modalEliminar = (id) => {
        warningModal('¿QUIERES ELIMINAR ESTA CATEGORIA?')
        .then(async (result) => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="Registro eliminado"){
                        getCategorias();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        });
    };

    //AGREGAR
    const store = async (e) => {
        e.preventDefault();
        setSaving(true);
        if(nombreCategoria.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const formdata = new FormData();
            formdata.append("image", imagenCategoria);
            formdata.append("name", nombreCategoria);
            const endpoint = uri;
            const res = await postApiImg(endpoint,formdata);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleClose();
                    getCategorias();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    };
    
    //EDITAR
    const update = async (e) => {
        e.preventDefault();
        if(editnombreCategoria.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            if (editimagenCategoria === null) {
                const endpoint = uri + idMaterial;
                const data = {nombreCatMat: editnombreCategoria};
                const res = await putApi(endpoint,data);
                if(res.status === 1){
                    if(res.data.message==="¡Registro actualizado correctamente!"){
                        handleCloseEdit();
                        getCategorias();
                        successToast("EDITADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            } else {
                const formdata = new FormData();
                formdata.append("image", editimagenCategoria);
                formdata.append("name", editnombreCategoria);
                const endpoint = uri + idMaterial;
                const res = await putApiImg(endpoint,formdata);
                if(res.status === 1){
                    if(res.data.message==="¡Registro actualizado correctamente!"){
                        handleCloseEdit();
                        getCategorias();
                        successToast("EDITADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        }
    };


    return (
        <div className="materiales">
            {
                isLoading ?
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">CATEGORIA DE MATERIALES</label>
                    </div>
                    <div className='divboton' >                                                                                             
                        <div className='boton' >
                            <button  className="btn  btncolor" type="button" onClick={handleShow}>
                            <label className="agregar">CATEGORIA</label><BsPlus style={{fontSize:'25px'}}/>    
                            </button>                                
                        </div>
                    </div>
                    {
                        categorias.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="categorias">
                                <div className="row row-cols-1 row-cols-md-4 g-4">
                                    {categorias.map((elemento) =>
                                        <div className="col-sm-6 mb-3 mb-sm-0  " key={elemento.idCatMat}>
                                            <div  className="cardCategoria">
                                                < img className="card__image_categoria" type="button" id={elemento.idCatMat} onClick={() => select(elemento.idCatMat)} 
                                                src={URIMG + elemento.imagenCatMat} as={Link} to="Tabla-Materiales" alt=""/>
                                                <div className="card__overlay_categoria">
                                                    <div className="card__header_categoria">
                                                        <svg className="card__arc_categoria" xmlns="http://www.w3.org/2000/svg"><path /></svg>                     
                                                        <div className="card__header-text_categoria" >
                                                            <h3 className="card__title_categoria">{elemento.nombreCatMat}</h3> 
                                                            <button className="btn-circle" title="Editar" onClick={() => handleShowEdit(elemento.idCatMat,elemento.nombreCatMat,elemento.imagenCatMat)}>
                                                                    <span className="bi bi-pen"></span>
                                                            </button>
                                                            <button className="btn-circle" title="Eliminar" onClick={() => modalEliminar(elemento.idCatMat)}>
                                                                <span className="bi bi-trash"></span>
                                                            </button>           
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>  
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    }

                    {/*AGREGAR MATERIAL*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-material">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR HERRAMIENTA</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={store}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', height:'60vh',overflowX:"scroll"}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setNombreCategoria(e.target.value) }/>
                                </div>             
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">IMAGEN <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="file" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setImagenCategoria(e.target.files[0]) }/>
                                </div>
                                <div className=" mb-3">
                                    <div style={{textAlign:"center",}}>
                                        <img src={imagenCategoria === null ?null:URL.createObjectURL(imagenCategoria)} width={'50%'} alt={nombreCategoria}/>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleClose}>CANCELAR</Button>                                               
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>

                    {/*EDITAR MATERIAL*/}
                    <Modal  show={showEdit} onHide={handleCloseEdit} id="modal-editar-material">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR MATERIAL</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', height:'60vh',overflowX:"scroll"}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" defaultValue={editnombreCategoria} 
                                    onChange={(e) => setEditNombreCategoria(e.target.value) }  required/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">IMAGEN </label>
                                    <input type="file" className="form-control"  id="exampleFormControlInput1" 
                                    onChange={e => setEditImagenCategoria(e.target.files[0]) }/>
                                </div>
                                <div className=" mb-3">
                                    <div style={{textAlign:"center",}}>
                                        <img src={editimagenCategoria === null ? URIMG + imgCat:URL.createObjectURL(editimagenCategoria)} width={'50%'} alt={imgCat}/>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</Button>
                                <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    );
}
export default Categorias;
